import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { UserManagementRoute } from '../../../routes/routes';

const Redirect: React.FunctionComponent = () => {
  const history = useHistory();
  // useUserRedirection();
  useEffect(() => {
    history.push(UserManagementRoute.path);
  }, [history]);

  return <></>;
};

export default Redirect;
